import { Tooltip, useTheme } from '@material-ui/core';
import { AgentChatTransferStatus } from '@src/model/frontendmodel';
import { getUserId } from '@src/selectors/user';
import { ChatTray } from '@src/types/chats';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { ArrowBackIcon, ArrowForwardIcon } from './SvgIcons';
import IconWrapper from '../Common/IconWrapper';

export type ChatTransferIndicatorProps = {
  chat: ChatTray;
};

const ChatTransferIndicator: React.FC<ChatTransferIndicatorProps> = ({
  chat: { chatXferRequest },
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const userId = useSelector(getUserId);
  const isTransferredToMe = chatXferRequest?.sourceAgent?.id === userId;

  if (
    !chatXferRequest?.chatId ||
    chatXferRequest?.status === AgentChatTransferStatus.CANCELLED
  )
    return null;

  return isTransferredToMe ? (
    <Tooltip
      title={intl.formatMessage({
        id: 'Console.ChatListItem.tooltip.TransferRequest',
      })}
    >
      <IconWrapper color={theme.b2chatorange[600]} fontSize={15.5}>
        {ArrowForwardIcon}
      </IconWrapper>
    </Tooltip>
  ) : (
    <Tooltip
      title={intl.formatMessage({
        id: 'Console.ChatListItem.tooltip.TransferRequested',
      })}
    >
      <IconWrapper color={theme.b2chatorange[600]} fontSize={15.5}>
        {ArrowBackIcon}
      </IconWrapper>
    </Tooltip>
  );
};

export default ChatTransferIndicator;
